<!--
  ~ Copyright (c) 2021.
  ~ 2iPartners SàRL and/or its affiliates.
  ~ All rights reserved.
  ~
  ~ 2iPartners SàRL
  ~ Route de Compois 24,
  ~ 1252 Meinier
  ~ Suisse
  ~
  ~ tel : +41 22 735 97 07
  -->

<h4 class="text-center" mat-dialog-title i18n="@@removalNotPossible">Impossible removal</h4>

<div mat-dialog-content>
  <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-center">
    <strong i18n="@@caution">Caution</strong>

    <p i18n="@@thirdPartyLockedInfo">
      You are not allowed to use the site to make your removals, please contact us using phone:
    </p>

    <img src="../../../../assets/img/num_indigo.png" alt="Provalt">
  </div>
</div>

<div mat-dialog-actions>
  <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
    <button class="btn btn-secondary btn-rounded btn-block text-uppercase" (click)="close()" i18n="@@ok">Ok</button>
  </div>
</div>
